import script from "./WithdrawTotals.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawTotals.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawTotals.vue?vue&type=style&index=0&id=27e23edc&scoped=true&lang=css"
script.__scopeId = "data-v-27e23edc"

export default script